export class Rating {
    ident:number;
    game:string;
    username:string;
    stars:number;
    rated_on:Date;
}
